// saga.js
import { call, put, takeLatest } from "redux-saga/effects";
import changePasswordApi from "./ChagePasswordEffect";
import { CHANGE_PASSWORD_REQUEST } from "./ChangePasswordType";
import { changePasswordFailure, changePasswordSuccess } from "./ChangePasswordAction";



function* handleChangePassword(action) {
  console.log("Change Password" ,action)
  try {
    const response = yield call(changePasswordApi, action.payload);
    yield put(changePasswordSuccess(response.message));//here reponse come like{message:"some"}so use reponse.message this will set action from action go to reducer
  } catch (error) {
    yield put(changePasswordFailure(error.message));
  }
}

export default function* changePasswordSaga() {
  yield takeLatest(CHANGE_PASSWORD_REQUEST, handleChangePassword);
}
